import React, { useEffect, useState } from "react";
import { ALL } from "./eventFilterUtils";

const PillGroup = ({ label, options, selected, onSelect }) => (
  <div className="ef-group">
    <div className="ef-group__label">{label}</div>
    <div className="ef-group__pills">
      <button
        type="button"
        className={`ef-pill ${selected === ALL ? "is-selected" : ""}`}
        onClick={() => onSelect(ALL)}
      >
        All
      </button>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`ef-pill ${selected === opt.value ? "is-selected" : ""}`}
          onClick={() => onSelect(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
    {options.length === 0 && (
      <div className="ef-group__empty">
        No {label.toLowerCase()} found in this schedule.
      </div>
    )}
  </div>
);

const EventFilterPanel = ({
  open,
  onClose,
  studios = [],
  sessions = [],
  value, // { studio, session, entry }
  onApply, // (nextFilters) => void
}) => {
  const [draft, setDraft] = useState({ studio: ALL, session: ALL });

  // panel khulte hi currently applied filters se sync (entry search alag rehta hai)
  useEffect(() => {
    if (open) {
      setDraft({
        studio: value?.studio ?? ALL,
        session: value?.session ?? ALL,
      });
    }
  }, [open, value]);

  // ESC se close + background scroll lock
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    document.body.classList.add("ef-no-scroll");
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.classList.remove("ef-no-scroll");
    };
  }, [open, onClose]);

  if (!open) return null;

  const handleUpdate = () => {
    // entry search ko chhede bina sirf studio/session update karo
    onApply((prev) => ({ ...prev, ...draft }));
    onClose();
  };

  return (
    <div className="ef-overlay" onClick={onClose}>
      <aside
        className="ef-panel"
        role="dialog"
        aria-modal="true"
        aria-label="Filters"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ef-panel__head">
          <h3 className="ef-panel__title">Filters</h3>
          <button
            type="button"
            className="ef-close"
            onClick={onClose}
            aria-label="Close filters"
          >
            &times;
          </button>
        </div>

        <div className="ef-panel__body">
          <div className="ef-panel__clear-row">
            <button
              type="button"
              className="ef-clear-link"
              onClick={() => setDraft({ studio: ALL, session: ALL })}
            >
              <span aria-hidden="true">&#10005;</span> Clear Filters
            </button>
          </div>

          <PillGroup
            label="Studio"
            options={studios}
            selected={draft.studio}
            onSelect={(v) => setDraft((d) => ({ ...d, studio: v }))}
          />

          <PillGroup
            label="Session"
            options={sessions}
            selected={draft.session}
            onSelect={(v) => setDraft((d) => ({ ...d, session: v }))}
          />
        </div>

        <div className="ef-panel__foot">
          <button
            type="button"
            className="ef-btn ef-btn--ghost"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="ef-btn ef-btn--primary"
            onClick={handleUpdate}
          >
            Update
          </button>
        </div>
      </aside>
    </div>
  );
};

export default EventFilterPanel;